import clsx from "clsx";
import { PointsBalanceFieldRoot } from "./PointsBalanceField.styles";
import { NumericTextFieldProps } from "ui/common/components/input/NumericTextField/NumericTextField.types";
import usePointsBalanceField from "./hook/usePointsBalanceField";

export interface PointsBalanceFieldProps extends Omit<NumericTextFieldProps, "hint" | "validators" | "maxDecimals"> {
    loading?: boolean;
    validators?: {
        //TODO: add more validators if needed
        gt?: string;
        gte?: string;
        lte?: string;
    };
}

function PointsBalanceField({ className, ...rest }: PointsBalanceFieldProps) {
    const numericTextFieldProps = usePointsBalanceField(rest);

    return <PointsBalanceFieldRoot className={clsx("balance-field", className)} {...numericTextFieldProps} />;
}

export default PointsBalanceField;
